module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hans/1-9da245eb0aea0ac00916f1ee13f0ddb2.jpg";